import { showNotification } from '@mantine/notifications';

type MantineNotificationParams = {
  id?: string;
  title: string;
  message: string;
};

const activeNotificationIds = new Set<string>();

export function successNotification(params: MantineNotificationParams) {
  showNotification({
    id: params.id,
    title: params.title,
    message: params.message,
    color: 'green',
  });
}

export function errorNotification(params: MantineNotificationParams) {
  if (params.id && activeNotificationIds.has(params.id)) return;

  if (params.id) {
    activeNotificationIds.add(params.id);
  }

  showNotification({
    id: params.id,
    title: params.title,
    message: params.message,
    color: 'red',
    onClose: () => {
      if (params.id) activeNotificationIds.delete(params.id);
    },
  });
}
